import { EPageType } from 'shared/models';

import V_FEED from './v_feed.png';
import V_ARTICLE from './v_article.png';
import V_VIDEO from './v_video.png';
import V_DISCOVER from './v_discover.png';
import V_POI from './v_poi.png';
import V_HASHTAG from './v_hashtag.png';
import V_USER from './v_user.png';
import V_SEARCH from './v_search.png';

import INHOUSE_FEED from './inhouse_feed.png';
import INHOUSE_ARTICLE from './inhouse_article.png';
import INHOUSE_VIDEO from './inhouse_video.png';
import INHOUSE_DISCOVER from './inhouse_discover.png';
import INHOUSE_POI from './inhouse_poi.png';
import INHOUSE_HASHTAG from './inhouse_hashtag.png';
import INHOUSE_USER from './inhouse_user.png';
import INHOUSE_SEARCH from './inhouse_search.png';

export const QRCODE_MAP: { [key in EPageType]: string } =
  __BUILD_TYPE__ === 'online'
    ? {
        [EPageType.feed]: V_FEED,
        [EPageType.article]: V_ARTICLE,
        [EPageType.video]: V_VIDEO,
        [EPageType.discover]: V_DISCOVER,
        [EPageType.experience]: V_DISCOVER,
        [EPageType.experience_article]: V_DISCOVER,
        [EPageType.poi]: V_POI,
        [EPageType.hashtag]: V_HASHTAG,
        [EPageType.user]: V_USER,
        [EPageType.user_follow]: V_USER,
        [EPageType.user_topic]: V_USER,
        [EPageType.search_sug]: V_SEARCH,
      }
    : {
        [EPageType.feed]: INHOUSE_FEED,
        [EPageType.article]: INHOUSE_ARTICLE,
        [EPageType.video]: INHOUSE_VIDEO,
        [EPageType.discover]: INHOUSE_DISCOVER,
        [EPageType.experience]: INHOUSE_DISCOVER,
        [EPageType.experience_article]: INHOUSE_DISCOVER,
        [EPageType.poi]: INHOUSE_POI,
        [EPageType.hashtag]: INHOUSE_HASHTAG,
        [EPageType.user]: INHOUSE_USER,
        [EPageType.user_follow]: INHOUSE_USER,
        [EPageType.user_topic]: INHOUSE_USER,
        [EPageType.search_sug]: INHOUSE_SEARCH,
      };
